import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import {
  selectAddressCurrentContractActive,
  selectAddressesConfigData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import useRetrieveActiveContractIdAndType from '@/containers/SubscriptionFormPageNew/Layouts/useRetrieveActiveContractIdAndType'
import { selectAuthData } from '../../../Login/AuthSelectors'

const useDistributor = () => {
  const { t } = useTranslation()
  const { cityEligibility, label = '', zipcode = '' } = useSelector(selectAddressCurrentContractActive)
  const { activeTab } = useRetrieveActiveContractIdAndType()
  const addressesConfig = useSelector(selectAddressesConfigData)

  const eldElectricity = cityEligibility?.elec_eld_details ?? {}
  const eldGas = cityEligibility?.gas_eld_details ?? {}
  const eldWater = cityEligibility?.water_details ?? {}
  const { country } = useSelector(selectAuthData)

  const buildAddress = (label, zipcode) => {
    const safeLabel = label?.trim()
    const safeZip = zipcode?.trim()
    if (safeLabel && safeZip) return `${safeLabel} (${safeZip})`
    if (safeLabel) return safeLabel
    if (safeZip) return safeZip
    return ''
  }

  const address = buildAddress(label, zipcode)

  const noDistributorData =
    Object.keys(eldElectricity).length === 0 && Object.keys(eldGas).length === 0 && Object.keys(eldWater).length === 0

  const isCityEligibilityLoading = addressesConfig?.addressCityEligibilityIsLoading ?? false

  return {
    t,
    activeTab,
    eldElectricity,
    eldGas,
    eldWater,
    address,
    noDistributorData,
    isCityEligibilityLoading,
    country,
  }
}

export default useDistributor
